import React, { useLayoutEffect, useRef, useState } from 'react';

export default function InlineNameEditor({
  value,
  onSave,
  onCancel,
  onDraftChange,
  className = 'text-xs',
}) {
  const [draft, setDraft] = useState(value);
  const inputRef = useRef(null);

  useLayoutEffect(() => {
    inputRef.current?.focus();
    inputRef.current?.select();
  }, []);

  const commit = () => {
    const trimmed = draft.trim();
    if (!trimmed) {
      onCancel();
      return;
    }
    onSave(trimmed);
  };

  return (
    <input
      ref={inputRef}
      type="text"
      value={draft}
      onChange={(e) => {
        const next = e.target.value;
        setDraft(next);
        onDraftChange?.(next);
      }}
      onKeyDown={(e) => {
        e.stopPropagation();
        if (e.key === 'Enter') {
          e.preventDefault();
          commit();
        } else if (e.key === 'Escape') {
          e.preventDefault();
          onCancel();
        }
      }}
      onBlur={commit}
      onClick={(e) => e.stopPropagation()}
      onPointerDown={(e) => e.stopPropagation()}
      className={`flex-1 min-w-0 font-medium text-gray-900 bg-white border border-blue-300 rounded px-1 py-0.5 focus:outline-none focus:ring-1 focus:ring-blue-400 dark:bg-zinc-800 dark:text-zinc-100 dark:border-blue-500/50 ${className}`}
    />
  );
}
